<div class="login-background"></div>
<app-prenavigation></app-prenavigation>
<div class="card">
    <app-progress-dots *ngIf="loading"></app-progress-dots>
    <div *ngIf="error" class="error">{{ error }}</div>
    <app-error-reference-field *ngIf="referenceId" [referenceId]="referenceId"></app-error-reference-field>
    <a *ngIf="!loading && signupButton" href="/oprettelse">Gå til oprettelse</a>
    <a *ngIf="!loading && !signupButton" href="/login">Tilbage til login</a>

    <div class="help-note">
        <app-help-note></app-help-note>
    </div>
</div>